window.Home = window.Home || {};

const dependencyLoader = uri => {
  return new Promise((resolve) => {
    if (uri.substring(uri.lastIndexOf('.') + 1) === 'js') {
      let scriptTag = document.createElement('script');
      scriptTag.src = uri;
      scriptTag.async = true;
      scriptTag.onload = () => resolve();
      document.head.appendChild(scriptTag);
    } else if (uri.substring(uri.lastIndexOf('.') + 1) === 'html') {
      let linkTag = document.createElement('link');
      linkTag.rel = 'import';
      linkTag.href = uri;
      linkTag.onload = () => resolve();
      document.head.appendChild(linkTag);
    } else {
      return
    }
  });
};

const loadDependencies = (dependencyArray = []) => {
  if (dependencyArray.length <= 0) {
    return Promise.resolve();
  }
  const fsDependencyPaths = dependencyArray.map(path => FS.File.resolvePath(path));
  const loadingScripts = fsDependencyPaths.map(uri => dependencyLoader(uri))
  return Promise.all(loadingScripts);
};

// Import the social menu component if the experiment is enabled
if (FS.showEx('nlihpDiscoveryTopRightShareEx')) {
  loadDependencies([
    'components/webcomponentsjs/webcomponents-lite.js',
    'components/fs-social-menu/fs-social-menu.html'
  ])
}

window.Home.loadDependencies = loadDependencies;
